import { render } from "./itemsDetailedComponent.vue?vue&type=template&id=6a038402"
import script from "./itemsDetailedComponent.vue?vue&type=script&lang=js"
export * from "./itemsDetailedComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__